import React from 'react';
import { useEffect, useState } from 'react';
import Axios from 'axios';
import { Box , Flex,  Button, ButtonGroup } from "@chakra-ui/react"
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { Login, Home} from "./Components/Pages";
import AdminHome from "./Components/Pages/AdminHome";
import UserManagement from "./Components/Pages/UserManagement";
import PharmacistReqs from "./Components/Pages/PharmacistReqs";
import{MedicineList} from "./Components/UI/MedicineList";
import{MedicineDetails} from "./Components/UI/ProductDetails.jsx";
import{MedicineListControl} from "./Components/UI/MedicineListAdminPharma";
import{MedicineListwithSales} from "./Components/UI/MedicineListWithSales";
import {AddMedicine} from "./Components/UI/AddMed";
import Cart from "./Components/Pages/Cart";
import  Completion from "./Components/Pages/Completion";
import  Completion2 from "./Components/Pages/Completion2";
import  CreditPayment from "./Components/Pages/CreditPayment";
import ForgotPassword from './Components/Pages/ForgotPassword.jsx';
import PasswordReset from './Components/Pages/PasswordReset.jsx';
import PharmacistRegisterPage from './Components/Pages/PharmacistRegisterPage';
import OrderDetails from './Components/UI/orderDetails';
import UploadPrescription from './Components/Pages/UploadPrescription.jsx';
import ChatMessages from './Components/Pages/chatMessagesPatient.jsx';
import ChatMessagesDoctor from './Components/Pages/chatMessagesDoctor.jsx';
import SalesReport  from './Components/Pages/SalesReport.jsx';
import OrderCheckout from "./Components/Pages/OrderCheckout";
import OrderConfirmation from "./Components/Pages/OrderConfirmation";
import PrescriptionOrderSummary from "./Components/Pages/PrescriptionOrderSummary.jsx";
import PharmacistOrders from "./Components/Pages/PharmacistOrders.jsx";
import PharmacistHome from "./Components/Pages/PharmacistHome.jsx";
import PushNotificationBanner from "./Components/UI/PushNotificationBanner";
const getDefaultRouteForRole = (role) => {
  if (role === "pharmacist") return "/pharmacist/home";
  if (role === "admin") return "/admin-home";
  return "/home";
};
const hasCookie = (name) => {
  if (typeof document === "undefined") return false;
  return document.cookie
    .split(";")
    .map((entry) => entry.trim())
    .some((entry) => entry.startsWith(`${name}=`));
};

function App() {
  const [cookies] = useCookies(["token"]);

  const ProtectedRoute = ({ children, allowedRoles }) => {
    const location = useLocation();
    const hasToken = Boolean(cookies.token || hasCookie("token"));
    const role = cookies.role || null;
    if (!hasToken) {
      const isPatientRoute = allowedRoles && allowedRoles.includes("patient");
      return <Navigate to={isPatientRoute ? "/home" : "/login"} replace state={{ from: location }} />;
    }
    if (allowedRoles && role && !allowedRoles.includes(role)) {
      return <Navigate to={getDefaultRouteForRole(role)} replace />;
    }
    return children;
  };

  const PublicRoute = ({ children }) => {
    const role = cookies.role || null;
    const hasToken = Boolean(cookies.token || hasCookie("token"));
    if (hasToken && role) return <Navigate to={getDefaultRouteForRole(role)} replace />;
    return children;
  };

  const loginIns = ["Username", "Password"];

  return (
    <div >
      <PushNotificationBanner />
      <Routes>
      {/* const handlePacks = () => {
        navigate("/admin-packs");
    };

  const handleUsers = () => {
      navigate("/admin-users");
  };

  const handleReqs = () => {
      navigate("/admin-requests");
  }; */}
        <Route
          path="/"
          element={<Navigate to="/home" replace />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/pharmacist-register"
          element={
            <PublicRoute>
              <PharmacistRegisterPage />
            </PublicRoute>
          }
        />

        <Route
          path="/home"
          element={<Home />}
        />
        <Route
          path="/admin-home"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <AdminHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/doctor-home"
          element={
            <ProtectedRoute>
              <Navigate to="/pharmacist/home" replace />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pharmacist/home"
          element={
            <ProtectedRoute allowedRoles={["pharmacist"]}>
              <PharmacistHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pharmacist/orders"
          element={
            <ProtectedRoute allowedRoles={["pharmacist"]}>
              <PharmacistOrders />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-users"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <UserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-requests"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <PharmacistReqs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medicine"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <MedicineList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medicine/details/:medicineID"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <MedicineDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medicineControl"
          element={
            <ProtectedRoute>
              <MedicineListControl />
            </ProtectedRoute>
          }
        />
        <Route
          path="/medicine/sales"
          element={
            <ProtectedRoute>
              <MedicineListwithSales />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addMed"
          element={
            <ProtectedRoute>
              <AddMedicine />
            </ProtectedRoute>
          }
        />
        <Route
          path="/cart"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <Cart />
            </ProtectedRoute>
          }
        />
        <Route
          path="/home/creditPayment/:address"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <CreditPayment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/completion/:address/:intentid"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <Completion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/completion"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <Completion2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order/prescription/:orderId"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <PrescriptionOrderSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order/prescription/summary"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <PrescriptionOrderSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/PasswordReset"
          element={
            <PublicRoute>
              <PasswordReset />
            </PublicRoute>
          }
        />

        <Route
          path="/orderdetails"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <OrderDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orderDetails"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <OrderDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload-prescription"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <UploadPrescription />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order/checkout"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <OrderCheckout />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order/confirmed"
          element={
            <ProtectedRoute allowedRoles={["patient"]}>
              <OrderConfirmation />
            </ProtectedRoute>
          }
        />
        {/* Chat routes disabled - Socket.IO removed */}
        {/* <Route
          path="/chatwithdoctor/:username"
          element={
            <ProtectedRoute>
              <ChatMessages />
            </ProtectedRoute>
          }
        />
        <Route
          path="/chatwithpatient/:username"
          element={
            <ProtectedRoute>
              <ChatMessagesDoctor />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/salesReport"
          element={
            <ProtectedRoute>
              <SalesReport />
            </ProtectedRoute>
          }
        />

      
     
      </Routes>
    </div>
  );
}

export default App;
